import { render, staticRenderFns } from "./ReorderWidgetsModal.vue?vue&type=template&id=5bcad53c&scoped=true"
import script from "./ReorderWidgetsModal.vue?vue&type=script&lang=js"
export * from "./ReorderWidgetsModal.vue?vue&type=script&lang=js"
import style0 from "./ReorderWidgetsModal.vue?vue&type=style&index=0&id=5bcad53c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcad53c",
  null
  
)

export default component.exports